import { ReactElement, ReactNode, RefObject, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Draggable from 'react-draggable';
import { Paper, PaperProps } from '@material-ui/core';
import ModalTitle from './ModalTitle';
import ModalFooter from './ModalFooter';

interface IProps {
  children: ReactElement;
  contentIdAttribute?: string;
  open: boolean;
  fullWidth?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  title: ReactNode;
  titleClassName?: string;
  containerClassName?: string;
  className?: string;
  isDraggable?: boolean;
  onClose: () => void;
  footer?: ReactNode;
}

const DraggablePaperComponent = (props: PaperProps) => {
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <Draggable
      nodeRef={nodeRef as RefObject<HTMLDivElement>}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const Modal = ({
  children,
  contentIdAttribute = '',
  open,
  fullWidth,
  maxWidth = 'sm',
  title,
  titleClassName = '',
  containerClassName = '',
  className = '',
  isDraggable = false,
  onClose,
  footer,
}: IProps): ReactElement => {
  const handleClose = (event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return;
    }

    onClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      className={containerClassName}
      PaperProps={{ className }}
      onClose={handleClose}
      PaperComponent={isDraggable ? DraggablePaperComponent : undefined}
    >
      <ModalTitle isDraggable={isDraggable} titleClassName={titleClassName} onClose={onClose}>
        {title}
      </ModalTitle>
      <MuiDialogContent id={contentIdAttribute}>{children}</MuiDialogContent>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Dialog>
  );
};

export default Modal;
